(function(){
    'use strict';
    angular.module('app').controller('ComplianceDetailsController', ComplianceDetailsController);

    ComplianceDetailsController.$inject = [
        '$scope',
        '$q',
        'ComplianceService',
        '$routeParams',
        '$location',
        '$timeout',
        'toastr',
        'ConfirmationModalFactory',
        'ViewChangeNotificationFactory',
        'ComplianceAttachmentTable',
        'ComplianceRemindersTable',
        'ComplianceTriggerTable',
        'ComplianceLogsTable',
        'ComplianceConst',
        'DriverGroupTypes',
        'FleetService',
        '$window',
        '$rootScope',
        'FormHelpersService'
    ];

    function ComplianceDetailsController(
        $scope,
        $q,
        ComplianceService,
        $routeParams,
        $location,
        $timeout,
        toastr,
        ConfirmationModalFactory,
        ViewChangeNotificationFactory,
        ComplianceAttachmentTable,
        ComplianceRemindersTable,
        ComplianceTriggerTable,
        ComplianceLogsTable,
        ComplianceConst,
        DriverGroupTypes,
        FleetService,
        $window,
        $rootScope,
        FormHelpersService
    ) {
        const vm = this;
        vm.id = $routeParams.id;
        vm.compliance = {};
        vm.onSaveButtonClickHandler = onSaveButtonClickHandler;
        vm.searchDriverGroups = searchDriverGroups;
        vm.onBackButtonClickHandler = onBackButtonClickHandler;

        const routeChangeConfirmation = new ConfirmationModalFactory({}, {
            message: 'messages.warning.viewChange.MESSAGE',
            code: 'messages.warning.viewChange.CODE',
        });

        function isChanged(o, n) {
            return !angular.equals(cleanPayload(o), cleanPayload(n));
        }

        function showRouteChangeConfirmation(next) {
            routeChangeConfirmation.getInstance().result.then(function (cond) {
                if (cond) {
                    onRouteChange();
                    let nextRoute = next.$$route.originalPath;
                    if (_.contains(next.$$route.originalPath, ':')) {
                        nextRoute = nextRoute.split(':')[0];
                    }
                    $location.path(nextRoute);
                }
            });
        }

        const onRouteChange = $scope.$on('$routeChangeStart', function(event, next) {
            if(angular.isDefined(vm.complianceRaw) && vm.compliance !== {}) {
                if (isChanged(vm.compliance, vm.complianceRaw)) {
                    showRouteChangeConfirmation(next);
                    event.preventDefault();
                }
            }
        });

        function getDriverGroupData(params){
            const defer = $q.defer();
            FleetService.DriverGroups.getAll(data => {
                defer.resolve(data.content);
            }, error => {
                defer.reject(error)
                toastr.error('Unable to fetch driver groups', error.message);
            }, params);
            return defer.promise;
        }

        function searchDriverGroups(searchParam){
            getDriverGroupData({name: searchParam.search}).then(data => {
                vm.driverGroups = data;
            }, error => console.log(error.message));
        }

        function cleanPayload(compliance) {
            return {
                companyId: $rootScope.GlobalProfile.company.id,
                enabled: compliance.enabled || false,
                frequency: compliance.frequency.toUpperCase(),
                frequencyNumber: compliance.frequencyNumber,
                frequencyUnit: compliance.frequencyUnit.toUpperCase(),
                groupName: compliance.driverGroup.name, // NEED TO FIX THIS ONE HERE
                groupType: compliance.groupType,
                itemId: compliance.itemId,
                itemName: compliance.itemName,
                officeId: $rootScope.GlobalProfile.office.id,
                remindersEnabled: compliance.remindersEnabled || false,
                requiredToProceed: compliance.requiredToProceed || false
            }
        }

        function updateComplianceItemDetails() {
            vm.saveInProgress = true;
            ComplianceService.update(vm.id, cleanPayload(vm.compliance), result => {
                vm.saveInProgress = false;
                toastr.success('Data successfully updated');
                vm.complianceRaw = angular.copy(vm.compliance);
            }, err => {
                vm.saveInProgress = false;
                toastr.error(err.message);
            });
        }

        function createNewComplianceDetails() {
            vm.saveInProgress = true;
            ComplianceService.create(cleanPayload(vm.compliance), result => {
                onRouteChange();
                $location.path('/compliance/details/' + result.id);
                toastr.success('Data successfully created');
            }, err => {
                vm.saveInProgress = false;
                toastr.error(err.message);
            });
        }

        function getInvalidForms(forms) {
            return FormHelpersService.getInvalidForms(forms)
        }

        function setInvalidFormsToSubmitted(forms) {
            FormHelpersService.setFormsToSubmitted(forms);
        }

        function onSaveButtonClickHandler(...forms) {
            const invalidForms = getInvalidForms(forms);
            setInvalidFormsToSubmitted(forms);
            if(invalidForms.length !== 0){return false;}

            if(vm.id){
                updateComplianceItemDetails();
            }else{
                createNewComplianceDetails();
            }
        }

        function redirectToComplianceGrid() {
            $location.path('/compliance');
        }

        function onBackButtonClickHandler(){
            redirectToComplianceGrid();
        }

        function getComplianceDetails(id) {
            const defer = $q.defer();
            ComplianceService.getDetails(result => {
                defer.resolve(result);
            }, error => {
                defer.reject(error);
                toastr.error('Unable to fetch compliance details', error.message);
                $window.history.back();
            }, id);
            return defer.promise;
        }

        function initializeTables() {
            vm.complianceAttachmentTable = (new ComplianceAttachmentTable(vm.compliance)).tableData;
            vm.complianceRemindersTable = (new ComplianceRemindersTable(vm.compliance)).tableData;
            vm.complianceTriggerTable = (new ComplianceTriggerTable(vm.compliance)).tableData;
            vm.complianceLogsTable = (new ComplianceLogsTable(vm.compliance)).tableData;
        }

        function setComplianceSelectDriverGroup() {
            const defer = $q.defer();
            getDriverGroupData({name: vm.compliance.groupName}).then(data => {
                vm.compliance.driverGroup = data.length !== 0 ? data[0] : null;
                defer.resolve(vm.compliance.driverGroup);
            }, error => {
                defer.reject(error);
            });
            return defer.promise;
        }

        function passComplianceDataToView(data) {
            vm.compliance = angular.copy(data.compliance);
        }

        function setOriginalCopyOfTheComplianceData() {
            vm.complianceRaw = angular.copy(vm.compliance);
        }

        function loadComplianceDetailsData() {
            if (vm.id) {
                vm.isFetching = true;
                $q.all({compliance: getComplianceDetails($routeParams.id)}).then(data => {
                    passComplianceDataToView(data);
                    setComplianceSelectDriverGroup().then(data => {
                        initializeTables();
                        setOriginalCopyOfTheComplianceData();
                    });
                    vm.isFetching = false;
                });
            }
        }

        function setFrequenciesDataToView() {
            vm.frequencies = ComplianceConst.frequencies;
        }

        function setFrequencyUnitsDataToView() {
            vm.frequencyUnits = ComplianceConst.units;
        }

        function setDriverGroupTypesDataToView() {
            vm.driverGroupTypes = DriverGroupTypes;
        }

        function init() {
            setFrequenciesDataToView();
            setFrequencyUnitsDataToView();
            setDriverGroupTypesDataToView();
            loadComplianceDetailsData();
        }

        init();
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/compliance/ComplianceDetailsController.js